<div class="profile-overlay fade-in">
  <div class="profile-header">
    <div class="user-greeting">
      <h5 class="greeting-title">Olá, {{ primeiroNome }}!</h5>
      <div class="user-details">
        <span class="user-nome-completo">{{ usuario?.nome }}</span>
        <span class="user-orgao">{{ usuario?.lotacao }}</span>
      </div>
    </div>
    <button
      mat-icon-button
      aria-label="Sair"
      color="warn"
      class="logout-btn"
      matTooltip="Sair"
      matTooltipClass="fs-12"
      matTooltipPosition="below"
      (click)="logOut()"
    >
      <mat-icon>logout</mat-icon>
    </button>
  </div>

  <div class="profile-actions">
    <button
      mat-button
      class="action-btn profile-btn"
      (click)="goToProfile()"
    >
      <mat-icon>person</mat-icon>
      <span>Ver Perfil</span>
    </button>

    <button
      mat-button
      class="action-btn modules-btn"
      (click)="closeOverlay()"
    >
      <mat-icon>apps</mat-icon>
      <span>Seus Módulos</span>
    </button>

    <button
      mat-button
      class="action-btn password-btn"
      (click)="openResetPasswordDialog()"
    >
      <mat-icon>lock</mat-icon>
      <span>Alterar Senha</span>
    </button>
  </div>
</div>

